import { RequestParams } from "@types"

export const prepareRequestParamsWithExpands = (
  params: RequestParams,
  additionalExpands: string[]
) => {
  const paramsExpandsValue = params.expands

  const paramsExpands =
    typeof paramsExpandsValue === 'string' && paramsExpandsValue.length
      ? paramsExpandsValue.split(',')
      : []

  const { expands: _ignoredExpands, ...requestParams } = params

  return {
    requestParams,
    expands: [...new Set([...additionalExpands, ...paramsExpands])],
  }
}
